import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import Slider from "./Slider/SliderNL";
import Navbar from "./Navbar/Navbar_00";
import HomeContent from "./WEBContent/HomeContent/HomeContent_00";
import Footer from "./Footer/Footer_00";

import "./Pagina_04.css";

import * as Hosts from '../../Hosts';

import {
  set_language,
  reqGET,
  content_language
} from '../../Utils';

//import "swiper/swiper-bundle.min.css";

import Loader from '../../loader';

const Pagina = () => {
  
  const { pathname } = useLocation();

	const [, set_dados] = useState(null)
	const dados_config = useRef({})
	const content_list = useRef([])

  const [isloading, setLoading] = useState(true);

  const [/*lang*/, set_lang] = useState('pt');
  const [lang_id, set_lang_id] = useState('1');

  const getConfig = async (id, uid) => {

    if((id !== undefined && id !== null && id !== '') || (uid !== undefined && uid !== null && uid !== '')) {

      let res = []
      
      if(id !== undefined && id !== null && id !== '') {
        res = await reqGET(`${Hosts.SIMCore_API}/web/content/${Hosts.companycode}/${id}`)
      }
      else if(uid !== undefined && uid !== null && uid !== '') {
        res = await reqGET(`${Hosts.SIMCore_API}/web/content/uniqid/${Hosts.companycode}/${uid}`)
      }
      
      if(res.data.length > 0) {
        set_dados(dados_config.current = res.data[0])
        setLoading(false)
      }
      else {      
        setLoading(false)
      }

    }

  }

  useEffect(() => {

    if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
      set_lang('pt')
      set_language('pt')
      set_lang_id('1')
    }
    else {
      set_lang(localStorage.getItem('lang'))
      content_language.forEach(el => {
        if (el.code === localStorage.getItem('lang')) {
          set_lang_id(el.id)
        }
      })
    }

  }, [])

  useEffect(() => {

    (async () => {
      set_dados(content_list.current = []) 
      set_dados(dados_config.current = {}) 


      console.log('pathname', pathname)

      if(pathname.includes('/preview/')) {

        let id_aux = pathname.split('/').pop()
        if(id_aux !== '') {
          await getConfig(id_aux, '')
        }

      }
      else if(pathname.includes('/nl/')) {

        let aux_path_params = pathname.split('/nl/')
        aux_path_params = aux_path_params[1].split('/')
        if(aux_path_params[1] !== null && aux_path_params[1] !== '') {
          let nl_uid = aux_path_params[0]
          //let entity_uid = aux_path_params[1]

          await getConfig('', nl_uid)
        }
        else {
          let nl_uid = aux_path_params[0]

          await getConfig('', nl_uid)

        }
      
      }
 
    })()
    

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang_id])

  return (
    isloading ?
      <Loader />
    :
      <div id="nl_content" dir="ltr" lang="und" style={{ backgroundColor: '#EFEFEF' }}>
        <table width="100%" cellSpacing="0" cellPadding="0" role="none" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px', padding: '0', margin:'0', width: '100%', height: '100%', backgroundRepeat: 'repeat', backgroundPosition: 'center top', backgroundColor: '#EFEFEF' }} >
          <tbody>
            <tr style={{ borderCollapse: 'collapse' }} >
              <td valign="top" style={{ padding: '0', margin: '0' }} >
                <Navbar pag_welcome={true} dados_config={dados_config.current} dados_navbar={{ info: { header: { info: { tag: 'page-04' }}}}} />
                <Slider pag_welcome={true} dados_config={dados_config.current} />
                {
                dados_config.current.content[0].section !== undefined ?
                  dados_config.current.content[0].section.map((el_content, k_content) => {
                    return (
                    <HomeContent key={k_content} pag_welcome={true} dados_config={dados_config.current} dados_component={el_content} tag_page={'04'} />
                    )
                  })
                :
                  null
                }
                {
                dados_config.current.content[0].components !== undefined ?
                  dados_config.current.content[0].components.map((el_content, k_content) => {
                    return (
                      <HomeContent key={k_content} pag_welcome={true} dados_config={dados_config.current} dados_component={el_content} component_order={k_content} tag_page={'04'} />
                    )
                  })
                :
                  null
                }
                <Footer pag_welcome={true} dados_config={dados_config.current} dados_navbar={{ info: { header: { info: { tag: 'page-04' }}}}} />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
  )
}

export default Pagina;